































import Vue from 'vue'

export default Vue.extend({
    name: 'Input',
    props: {
        value: {
            type: String,
            default: '' // value of input
        },

        title: {
            type: String,
            default: ''
        },

        hasTitle: {
            type: Boolean,
            default: true
        },

        placeholder: {
            type: String,
            default: ''
        },

        type: {
            type: String,
            default: 'text' // type of input
        },

        errMsg: {
            type: String,
            default: '' // error msg when validate failed
        },

        required: {
            type: Boolean,
            default: false // if field required
        },

        regex: {
            type: RegExp,
            default: () => (new RegExp('(.*?)')) // value should match regex
        },

        validator: { // needs to be removed
            type: Function,
            default: null
        },

        vuelidater: {
            type: Object,
            default: () => ({$invalid: false})
        },

        validateOnInit: {
            type: Boolean,
            default: false
        },

        equal: {
            type: String,
            default: '' // value should equal to, otherwise has error
        },

        disabled: {
            type: Boolean,
            default: false // if disabled
        },

        focused: {
            type: Boolean,
            default: false // if set to focused by default
        },

        resetBit: {
            type: Boolean,
            default: false
        },

        autocomplete: {
            type: String,
            default: undefined
        },

        inputmode: {
            type: String,
            default: undefined
        }

    },
    data() {
        return {
            hasFocused: this.validateOnInit || !!this.value, // if has focused once
            focusing: false // if currently focusing
        }
    },

    computed: {
        hasError(): boolean | '' {
            if (this.vuelidater.$invalid) {
                return true
            }
            if(this.validator) {
                return !this.validator(this.value)
            }
            if (this.value) {
                let hasError = false
                if (this.regex) {
                    hasError = hasError || !(this.value && this.value.match && this.value.match(this.regex))
                }
                if (this.equal) {
                    hasError = hasError || !(this.equal && this.value && this.value === this.equal)
                }
                return hasError
            }
            return this.required
        },

        // input class object
        inputClass(): object {
            return {
                'position-focused': this.hasFocused && this.hasTitle,
                'border-focus': this.focusing, // when focusing, show blue border, even error
                // after focused, if error, show error border
                'border-error': !this.focusing && this.hasFocused && this.hasError,
                'has-no-title': !this.hasTitle
            }
        },

        // input title class object
        titleClass(): object {
            return {
                'text-danger': !this.focusing && this.hasFocused && this.hasError
            }
        },

        titleText(): string {
            return !this.focusing && this.hasError ? this.errMsg : this.title
        },

        asteriskClass(): object {
            return {
                'text-danger': !this.focusing && this.hasFocused && this.hasError,
                'asterisk-success': !this.focusing && this.hasFocused && !this.hasError
            }
        },

        asteriskIconClass(): object {
            if (!this.focusing && this.hasFocused && !this.hasError) {
                return {'uk-icon-check': true}
            } else if (this.required) {
                return {'uk-icon-asterisk': true}
            } else {
                return {}
            }
        }
    },
    watch: {
        hasError: function(hasError) {
            this.$emit('has-error', hasError)
        },

        resetBit: function(resetBit) {
            this.hasFocused = false
        }
    },
    methods: {
        onFocusOut() {
            this.focusing = false
        },

        onFocus() {
            this.focusing = true
            this.hasFocused = true
            this.$emit('focused', true)
        },

        focus() {
            (this.$refs.input as any).focus()
        }
    }
})
